import { all } from 'redux-saga/effects';
import markReadNotification from './mark-as-read';
import getNotificationList from './notification-list';

export const notificationSaga = function* root() {
  yield all([getNotificationList(), markReadNotification()]);
};
